import { Injectable, inject } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { Router } from '@angular/router';
import {
  ReAuthorization,
  StartRegistrationNewUser,
} from '@modules/authorization/store/authorization.action';
import { errorsUri } from '@modules/errors/errors.const';
import { ProposalApiConstants } from '@modules/order/order.const';
import { AppState } from '@modules/shared/store';
import { HideSpinnerLoading } from '@modules/shared/store/common.actions';
import { Store } from '@ngrx/store';

@Injectable({
  providedIn: 'root',
})
export class ErrorsService {
  private router = inject(Router);
  private store = inject<Store<AppState>>(Store);

  public showError(
    error: ValidationErrors,
    url?: string,
    params?: { [key: string]: string }
  ): void {
    this.store.dispatch(new HideSpinnerLoading());

    if (
      error.status === 500 ||
      error.status === 501 ||
      error.status === '501' ||
      error.status === 400
    ) {
      this.router.navigateByUrl(`/${errorsUri.unknown}`, {
        state: {
          ...params,
        },
      });
    } else if (error.status === 403) {
      if (localStorage.getItem('authorized') === 'true') {
        localStorage.removeItem('processId');
        localStorage.removeItem('authorized');
        this.store.dispatch(new ReAuthorization());
      } else {
        this.store.dispatch(new StartRegistrationNewUser());
      }
      // this.router.navigateByUrl(`/${ errorsUri.auth }`);
      this.router.navigateByUrl(`/`);
    } else if (error.status === 404 || error.status === 405) {
      this.router.navigateByUrl(`/${errorsUri.pageNotFound}`, {
        state: {
          ...params,
        },
      });
    } else if (
      error.status === 502 &&
      (url?.includes(ProposalApiConstants.sendApplicationInBank) ||
        url?.includes(ProposalApiConstants.getPartnerRedirectUrl))
    ) {
      this.router.navigateByUrl(`/${errorsUri.proposalSend}`, {
        state: {
          ...params,
        },
      });
    } else if (error.status === 502 || error.status === 504) {
      this.router.navigateByUrl(`/${errorsUri.temporarilyUnavailable}`, {
        state: {
          ...params,
        },
      });
    } else if (error.errorInfo.error === '10003') {
      this.router.navigateByUrl(`/${errorsUri.proposalCreate}`, {
        state: {
          ...params,
        },
      });
    } else if (error.errorInfo.error === '10000') {
      this.router.navigate([`/${errorsUri.noPaymentRequirements}`], {
        state: {
          text: error.errorInfo.errorText,
          ...params,
        },
      });
    } else if (error.errorInfo.error === '10004') {
      this.router.navigateByUrl(`/${errorsUri.proposalNotFound}`, {
        state: {
          ...params,
        },
      });
    } else if (error.errorInfo.error === '10005') {
      this.router.navigateByUrl(`/${errorsUri.proposalCreated}`, {
        state: {
          ...params,
        },
      });
    } else if (error.errorInfo.error === '10006') {
      this.router.navigateByUrl(`/${errorsUri.proposalRejected}`, {
        state: {
          ...params,
        },
      });
    } else if (error.errorInfo.error === '11003') {
      this.router.navigateByUrl(
        `/${errorsUri.questionnaireFillingTimeExpired}`,
        {
          state: {
            ...params,
          },
        }
      );
    }
  }
}
